export abstract class Range {
  static getNumbers(size: number, startAt: number = 0): Array<number> {
    return Array.from(Array(size).keys(), (i) => i + startAt);
  }
}
